import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { environment } from './environments/environment';

// Deshabilitar console en producción
// TEMPORAL — deshabilitado localmente solo para depurar el filtro de tipo de
// jornada. NO comitear así. Revertir (descomentar) apenas se termine.
// if (environment.production) {
//   console.log = () => {};
//   console.debug = () => {};
//   console.info = () => {};
//   console.warn = () => {};
//   console.error = () => {};
// }

bootstrapApplication(App, appConfig).catch((err) => console.error(err));
